<mat-card class="card-horizontal">

  @if (person) {
    <mat-card-header class="col-md-5">
      <i class="fa-solid fa-user" matCardAvatar></i>
      <mat-card-title>{{'personDetails.title' | translate}}</mat-card-title>
      <mat-card-subtitle>{{ 'personDetails.subText' | translate: { firstName: person.firstName, lastName:
        person.lastName } }}</mat-card-subtitle>
    </mat-card-header>
  }

  <mat-card-content class="col-md-7">
    @if (loading) {
    <mat-spinner></mat-spinner>
    } @else {
    @if (person !== null) {
    <p>
      <strong>{{ 'email' | translate }}</strong><br />
      {{person.email}}
    </p>
    <p>
      <strong>{{ 'accessToSharePointFolder' | translate }}</strong><br />
      {{person.sharePointFolderName}}
    </p>
    <p>
      <strong>{{ 'personOverview.rights' | translate }}</strong><br />
      {{person.rights}}
    </p>
    <p>
      <strong>{{ 'createdOn' | translate }}</strong><br />
      {{person.created | date:'dd-MM-yyyy HH:mm:ss'}}
    </p>
    @for (value of person.tokens; track value) {
    <div>
      @if (value.isActive) {
      <div>
        <p>
          <strong>Token</strong> <br />
          {{ 'personDetails.activeStatus' | translate: { guid: value.guid } }}
        </p>
        <p>
          <strong>{{ 'upToAndIncluding' | translate }} </strong> <br />
          {{value.expireDateToken | date:'dd-MM-yyyy HH:mm:ss'}}
        </p>
      </div>
      } @else {
      <p>{{ 'personDetails.inactiveStatus' | translate: { guid: value.guid } }}</p>
      }
    </div>
    }
    }
    }

  </mat-card-content>

  <mat-card-actions class="col-md-1">
    <button mat-stroked-button type="button" routerLink="/person-view" [disabled]="isPersonCreated">
      {{ 'back' | translate }}
    </button>
  </mat-card-actions>
  <mat-card-actions class="col-md-6 ms-auto">
    @if (person) {
    <button mat-flat-button type="button" color="primary" [disabled]="disableTokenButton" (click)="openConfirmDialog()">
      {{ 'personDetails.sendInvitation' | translate }}
    </button>
    <!-- <button mat-flat-button type="button" color="primary" [routerLink]="['/', 'person-edit', person.guid]">
      {{ 'modify' | translate }}
    </button> -->
    }
  </mat-card-actions>
</mat-card>
